import React, { useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { isEmpty, isString } from "lodash";
import { H3, TextArea } from "orcs-design-system";

export const Name = ({ team, isEditing, setNewName, newName }) => {
  const onNameChange = useCallback(
    (event) => {
      const value = event?.target?.value ?? null;
      setNewName(value);
    },
    [setNewName]
  );

  const isValid = useMemo(() => {
    return isString(newName) && !isEmpty(newName);
  }, [newName]);

  if (isEditing) {
    return (
      // TODO: Limit resizing to vertical, see: https://github.com/orchestrated-io/orcs-design-system/issues/382
      <TextArea
        type="text"
        placeholder="Team Name"
        ariaLabel="Team Name"
        focust={true}
        value={team.name}
        onChange={onNameChange}
        fullWidth
        rows={2}
        valid={isValid}
        invalid={!isValid}
      />
    );
  }

  return (
    <H3 mb="xs" textAlign="center">
      {team.name}
    </H3>
  );
};

Name.propTypes = {
  team: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  setNewName: PropTypes.func.isRequired,
  newName: PropTypes.string.isRequired,
};
